<app-modal-wrapper [(isValid)]="isValid" (save)="onSave($event)" (cancel)="onCancel($event)" [options]="options">
  <div class="search-save-poup-container card-body">
    <div class="form-group col-12">
      <label class="form-label">Enter a name for the saved query</label>
      <input type="text" [(ngModel)]="saveName" style="width: 100%" maxlength="100" (keyup)="onKeyUp($event)" />
    </div>
  </div>
</app-modal-wrapper>
